import React, { useEffect, useRef, useState } from 'react';

const Steps = ({ segments, numberOfChildrenListener, stepsCounter }) => {

    const scrollRef = useRef(null);
    const [showArrow, setShowArrow] = useState(false);

    const scrollToBottom = () => {
        const el = scrollRef.current;
        if (!el) return;

        el.scrollTo({
            top: el.scrollHeight,
            behavior: 'smooth',
        });
    }

    useEffect(() => {

        const el = scrollRef.current;
        if (!el) return;

        const handleScroll = () => {
            const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
            setShowArrow(!isBottom);
        };

        el.addEventListener('scroll', handleScroll);
        handleScroll(); // initial check

        return () => el.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const isOverflowing = el.scrollHeight > el.clientHeight;
        setShowArrow(isOverflowing);
    }, [numberOfChildrenListener]);


    return (
        <>
            <div ref={scrollRef} className={`max-h-[50vh] overflow-y-auto relative ${stepsCounter === 2 ? 'border-y' : ''}`}>
                {
                    segments[stepsCounter].component
                }

                <div className='sticky bottom-0 w-fit mx-auto animate-bounce'>
                    {
                        stepsCounter === 2 && showArrow ?
                            <div className='btn btn-sm btn-circle btn-secondary opacity-100 duration-300 transition-all' onClick={scrollToBottom}>
                                <svg className="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19V5m0 14-4-4m4 4 4-4" />
                                </svg>
                            </div>
                            :
                            <div className='btn btn-sm btn-circle btn-secondary opacity-0 duration-300 transition-all'>
                                <svg className="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19V5m0 14-4-4m4 4 4-4" />
                                </svg>
                            </div>
                    }
                </div>
            </div>



            <ul className="steps scale-75 transition-colors duration-1000">
                {
                    segments.map((segment, index) => (
                        <li
                            key={index}
                            className={`
                                step transition-colors duration-1000
                                ${stepsCounter < index ? '' : 'step-secondary'}
                            `}
                        >
                            <span className='text-xs'>{segment.title}</span>
                        </li>
                    ))
                }
            </ul>
        </>
    );
}

export default Steps;
